import { FETCH_CUSTOMERS } from '../actions/CustomerActions';

// INITIALIZE STATE

const initialState = {
    customers: null,
    fetching: false,
    fetched: false,
    failed: false,
    paging: {
        total: 0,
        pageNumber: 1,
        pageSize: 5,
        pages: 1,
    },
};

// REDUCER

export const CustomersReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSTOMERS}_PENDING`:
            return {
                ...state,
                customers: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_CUSTOMERS}_FULFILLED`:
            return {
                ...state,
                customers: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_CUSTOMERS}_REJECTED`:
            return {
                ...state,
                customers: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
